// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"6055e44f","75":"ee8494d5","167":"62507ecf","667":"2e69d4d6","701":"03b016e9","873":"cd7a0f83","915":"0f60469d"}[chunkId] + ".chunk.js";
};